import React from 'react';

export default (props) => (
  <svg viewBox="0 0 15.2 15.2" {...props}>
    <path fill="#58595B" d="M14.1,13.5l-0.9-3.1L14,9.7c0.2-0.2,0.2-0.4,0.1-0.6l-0.4-0.5c-0.1-0.2-0.4-0.2-0.6,0l-0.3,0.2l-0.3-1.2
		l0.8-0.7c0.2-0.2,0.2-0.4,0.1-0.6L13,5.8c-0.1-0.2-0.4-0.2-0.6,0L12,6.1l-0.2-0.8c1-1.1,1.9-2,2.4-2.5c1.4-1.6,1-2.7,0.9-2.7l0,0
		c0,0,0,0,0,0l0,0l0,0c-0.1,0-1.1-0.5-2.7,0.9C11.9,1.5,11,2.4,9.9,3.4L9.1,3.2l0.3-0.3c0.2-0.2,0.2-0.5,0-0.6L8.9,1.9
		C8.7,1.7,8.5,1.8,8.3,1.9L7.6,2.8L6.4,2.4l0.2-0.3c0.2-0.2,0.2-0.5,0-0.6L6.1,1.2C6,1,5.7,1.1,5.5,1.3L4.9,2L1.7,1.1
		c-0.2-0.1-0.4,0-0.6,0.2L0.9,1.6l5.4,3.4c0.1,0.1,0.2,0.2,0.3,0.3l0.6,0.8c-1.6,1.6-3,3.1-3.4,3.8l-3-0.5c-0.2,0-0.4,0-0.5,0.2
		L0,9.9l2.8,1.8c-0.9,1.2-1,1.7-1,1.7s0.6-0.1,1.7-1l1.9,2.8l0.4-0.3c0.2-0.1,0.2-0.3,0.2-0.5l-0.5-3C5.9,11,7.5,9.6,9.1,8l0.8,0.6
		c0.1,0.1,0.2,0.2,0.3,0.3l3.4,5.4l0.3-0.3C14.1,13.9,14.2,13.7,14.1,13.5z" />
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/svg/Airplane.js